import { render, staticRenderFns } from "./TypeMessage.vue?vue&type=template&id=67d970e9&scoped=true"
import script from "./TypeMessage.vue?vue&type=script&lang=js"
export * from "./TypeMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d970e9",
  null
  
)

export default component.exports